import styled from "styled-components";

export const Container = styled.div`
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* display: none; */
  z-index: 1000;

  #calculo {
    background: #fff;
    border-radius: 5px;
    padding: 2%;
    position: fixed;
    width: 30%;
    top: 20%;
    left: 35%;
    z-index: 1001;
  }

  #form {
    float: left;
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  #form input[type="text"] {
    border: 1px #ddd solid;
    padding: 20px;
    border-radius: 5px;
    width: 100%;
    text-align: center;
  }

  #total small {
    float: left;
    width: 100%;
    padding: 10px;
    font-size: 12px;
  }
  #total strong {
    float: left;
    width: 100%;
    font-weight: 900;
    font-size: 40px;
  }

  .fecha {
    position: absolute;
    top: -30px;
    right: 10px;
    width: 15px;
    cursor: pointer;
  }
`;
